
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-instructions/microsoft-office",
      function () {
        return require("private-next-pages/ai-optout-instructions/microsoft-office/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-instructions/microsoft-office"])
      });
    }
  